import { render } from "./index.vue?vue&type=template&id=188528a2"
import script from "./logistics.js?vue&type=script&lang=js&external"
export * from "./logistics.js?vue&type=script&lang=js&external"

import "./logistics.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__